import { createContext as t, use as o } from "react";
const e = t("light");
e.displayName = "SurgeThemeContext";
function n() {
  return o(e);
}
export {
  e as SurgeThemeContext,
  n as useTheme
};
